<script>
import Modal from "../../components/shared/Modal/Modal.vue";
import { DataService } from "../../config/dataService";
import store from "../../vuex/store";
import BillingForm from "../Billing/BillingForm.vue";
import DataPage from "../DataPage/DataPage.vue";

const CLIENT_ID = process.env.VUE_APP_GOOGLE_CLIENT_ID;
const API_KEY = process.env.VUE_APP_GOOGLE_API_KEY;
const DISCOVERY_DOC =
  "https://www.googleapis.com/discovery/v1/apis/drive/v3/rest";
const SCOPES = "https://www.googleapis.com/auth/drive.file";

const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;

export default {
  components: {
    DataPage,
    Modal,
    BillingForm,
  },
  data() {
    return {
      pickerApiLoaded: false,
      gapiInited: false,
      gisInited: false,
      billingModalShown: false,
    };
  },
  computed: {
    isLoading() {
      return store.getters.isLoading;
    },

    chosenWidget() {
      return store.state.users.chosenWidget;
    },

    isSubscriptionChecked() {
      const subscriptionStatus = this.chosenWidget?.owner?.subscription
        ? this.chosenWidget?.owner?.subscription?.status
        : this.chosenWidget?.owner?.subscription;

      if (subscriptionStatus || subscriptionStatus === "active") {
        return true;
      } else {
        return false;
      }
    },
  },

  watch: {},

  methods: {
    isScriptLoaded(src) {
      return Array.from(document.getElementsByTagName('script')).some(script => script.src === src);
    },
    addScript(src) {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.defer = true;
        script.onload = () => {
          console.log(`${src} loaded`);
          resolve();
        };
        script.onerror = () => {
          console.error(`${src} failed to load`);
          reject();
        };
        document.body.appendChild(script);
      });
    },
    async updateChosenWidget() {
      try {
        const result = await DataService.get(
          `${API_ENDPOINT}widget/get-by-id/${this.chosenWidget?.id}`
        );

        store.dispatch("setChosen", result?.data);
      } catch (error) {
        this.$toast.error(
          error?.response?.data?.errorDescription ||
            "Update chosen widget error"
        );
      }
    },

    async pickerCallback(data) {
      const toast = this.$toast;
      store.dispatch("startLoading");
      try {
        if (data?.action === google?.picker?.Action.PICKED) {
          const selectedFiles = data?.docs;

          if (selectedFiles.length > 0) {
            for (const file of selectedFiles) {
              const response = await DataService.post(
                `${API_ENDPOINT}widget/addSource/${this.chosenWidget?.id}`,
                {
                  sourceType: "googleDrive",
                  data: {
                    fileId: file?.id,
                    accessToken: gapi.client.getToken().access_token,
                    sources: [file.embedUrl],
                  },
                },
                {
                  widgetid: this.chosenWidget?.id,
                }
              );

              if (response?.status === 200) {
                toast.success("File successfully loaded");
              }
            }
          }
        }

        this.updateChosenWidget();
      } catch (e) {
        this.$toast.error(
          e?.response?.data?.errorDescription || "Picker callback error"
        );
      } finally {
        store.dispatch("endLoading");
      }
    },

    gapiLoaded() {
      gapi.load("client", this.initializeGapiClient);
    },
    async initializeGapiClient() {
      await gapi.client.init({
        apiKey: API_KEY,
        discoveryDocs: [DISCOVERY_DOC],
      });
      this.gapiInited = true;
    },

    gisLoaded() {
      this.tokenClient = google.accounts.oauth2.initTokenClient({
        client_id: CLIENT_ID,
        scope: SCOPES,
        callback: "",
      });
      this.gisInited = true;
    },

    async initializePicker() {
      await gapi.load("picker", () => {
        this.pickerApiLoaded = true;
      });
    },

    handleGoogleDriveAuth() {
      if (!this.isSubscriptionChecked) {
        return (this.billingModalShown = true);
      }

      if (!this.tokenClient) this.gisLoaded();
      this.tokenClient.callback = async (resp) => {
        if (resp.error !== undefined) {
          throw resp;
        }
        await this.showPicker();
      };

      if (gapi.client.getToken() === null) {
        this.tokenClient?.requestAccessToken({ prompt: "consent" });
      } else {
        this.tokenClient?.requestAccessToken({ prompt: "" });
      }
    },

    handleSignoutClick() {
      const token = gapi.client.getToken();
      if (token !== null) {
        google.accounts.oauth2.revoke(token.access_token);
        gapi.client.setToken("");
      }
    },

    async showPicker() {
      if (this.pickerApiLoaded) {
        const picker = new google.picker.PickerBuilder()
          .addViewGroup(
            new google.picker.ViewGroup(google.picker.ViewId.DOCS)
              .addView(google.picker.ViewId.DOCUMENTS)
              // .addView(google.picker.ViewId.PRESENTATIONS)
              .addView(google.picker.ViewId.PDFS)
            // .addView(google.picker.ViewId.SPREADSHEETS)
          )
          .setOAuthToken(gapi.client.getToken().access_token)
          .setDeveloperKey(API_KEY)
          .setCallback(this.pickerCallback)
          .build();
        picker.setVisible(true);
      }
    },
  },
  async mounted() {
    if (!this.isScriptLoaded('https://apis.google.com/js/api.js')) {
      await this.addScript('https://apis.google.com/js/api.js');
    }
    if (!this.isScriptLoaded('https://accounts.google.com/gsi/client')) {
      await this.addScript('https://accounts.google.com/gsi/client');
    }
    this.gapiLoaded();
    this.gisLoaded();
    this.initializePicker();
  },
};
</script>

<template>
  <div>
    <Modal :isModalOpen="billingModalShown" @close="billingModalShown = false">
      <div slot="body" class="modal_body">
        <BillingForm type="modal" />
      </div>
    </Modal>

    <DataPage
      @addClick="handleGoogleDriveAuth"
      dataType="googleDrive"
      title="Google Drive"
    />
  </div>
</template>

<style scoped>
.modal_body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  max-width: 600px;
}
</style>
